import { SettingConst } from '@faire/web-api--source/types';

/**
 * Set horizontal spacing for SDUI carousel components in the backend.
 */
export const ENABLE_BACKEND_CAROUSEL_COMPONENT_HORIZONTAL_SPACING_250318 =
  'ENABLE_BACKEND_CAROUSEL_COMPONENT_HORIZONTAL_SPACING_250318' as SettingConst<
    'ENABLE_BACKEND_CAROUSEL_COMPONENT_HORIZONTAL_SPACING_250318',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS'
  >;
